import React from 'react';
import { Link } from 'react-router';
import styles from './styles/Button.module.scss';

type ButtonProps = {
  className?: string;
  onClick?: React.MouseEventHandler;
  card?: boolean;
  noTab?: boolean;
  label?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  link?: string;
  newTab?: boolean;
  children: React.JSX.Element | string;
};

const Button: React.FunctionComponent<ButtonProps> = (props: ButtonProps) => {
  const { className, onClick, card, noTab, label, children, type, disabled, link, newTab } = props;

  if (!disabled && link && !link.includes('http')) {
    if (card) {
      return (
        <Link to={link} onClick={onClick} title={label} aria-label={label}>
          <span className={className ? styles[className] : styles.button}>{children}</span>
        </Link>
      );
    }
    return (
      <Link to={link} className={className ? styles[className] : styles.button} onClick={onClick} title={label} aria-label={label}>
        {children}
      </Link>
    );
  } else if (!disabled && link && link.includes('http')) {
    return (
      <a
        href={link}
        target={newTab ? '_blank' : undefined}
        rel={newTab ? 'noopener noreferrer' : undefined}
        className={className ? styles[className] : styles.button}
        onClick={onClick}
        title={label}
        aria-label={label}
      >
        {children}
      </a>
    );
  } else {
    return (
      <button
        className={className ? styles[className] : styles.button}
        onClick={onClick}
        tabIndex={noTab ? -1 : undefined}
        type={type ?? undefined}
        aria-disabled={disabled}
        title={label}
        aria-label={label}
      >
        {children}
      </button>
    );
  }
};

export default Button;
